import React from 'react';
import PropTypes from 'prop-types';

import { isEnterprisePlatform } from '../../../utils/platformHelper';
import { DefaultLogo } from '../Logo/DefaultLogo';
import { EnterpriseLogo } from '../Logo/EnterpriseLogo';

/**
 * Auth / splash branding — picks enterprise or default logo from platform.
 * @param {('login'|'splash')} brandScene — Preset logo margins differ: login vs other auth/splash flows.
 */
export const MedhaulAuthBrand = ({
  className,
  onClick,
  lg,
  md,
  sm,
  xl,
  width,
  height,
  marginTop,
  marginBottom,
  marginOnImage,
  brandScene = 'splash',
}) => {
  const enterprisePlatform = isEnterprisePlatform();
  const variant = brandScene === 'login' ? 'login' : 'splash';

  const logoProps = {
    className,
    onClick,
    lg,
    md,
    sm,
    xl,
    width,
    height,
    marginTop,
    marginBottom,
    marginOnImage,
    variant,
  };

  if (enterprisePlatform) {
    return <EnterpriseLogo {...logoProps} />;
  }

  return <DefaultLogo {...logoProps} />;
};

MedhaulAuthBrand.propTypes = {
  brandScene: PropTypes.oneOf(['login', 'splash']),
  className: PropTypes.string,
  onClick: PropTypes.func,
  lg: PropTypes.bool,
  md: PropTypes.bool,
  sm: PropTypes.bool,
  xl: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  marginTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  marginBottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  marginOnImage: PropTypes.bool,
};
